/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import React, { useEffect, useState } from "react";
import Box from "components/generals/Box";
import AccountsTable from "components/tables/AccountingTable";
import useHttp from "hooks/http.hook";
import { CoreAPI_URLs } from "constants/http.const";
import { AccountingInterface, QueryResultInterface } from "medicalsystem-shared";
import { useTranslation } from "react-i18next";
import { useResetPageOnFilter } from "hooks/tableReset.hook";

/**
 * Content component for displaying and managing accounting records.
 * Shows a table of all accounting entries with search, filtering, and pagination functionality.
 * Allows viewing of financial transactions and account details.
 * @returns {React.ReactElement} The accounting data content component
 */
const AccountingsDataContent: React.FC = () => {
  const [_isLoading, _error, sendRequest] = useHttp();
  const [accountingList, setAccountingList] = useState<AccountingInterface[]>([]);
  const [page, setPage] = useState<number>(1);
  const [pageTotal, setPageTotal] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [rowsTotal, setRowsTotal] = useState<number>(0);
  const [filterModel, setFilterModel] = useState<string>("");
  const { t } = useTranslation();

  const fetchAccountings = () => {
    const nameParam = filterModel ? `name=${filterModel}&` : "";
    const url = `${CoreAPI_URLs.ACCOUNTING_GET_ALL}?${nameParam}page=${page}&pageSize=${pageSize}`;
    sendRequest(url, onGetAccountingHandler, "GET");
  };

  useEffect(() => {
    fetchAccountings();
  }, [page, pageSize, filterModel]);

  useResetPageOnFilter(filterModel, page, setPage);

  const onGetAccountingHandler = (
    accountingsResponse: QueryResultInterface<AccountingInterface>
  ) => {
    setAccountingList(accountingsResponse.results);
    setRowsTotal(accountingsResponse.total);
    setPageTotal(Math.ceil(accountingsResponse.total / pageSize));
  };

  return (
    <Box>
      <AccountsTable
        modelList={accountingList}
        setModelList={setAccountingList}
        canSearch={true}
        canSearchPlaceholder={t("accountingsTable.searchPlaceholder")}
        entriesPerPage={{ defaultValue: pageSize }}
        setPageState={setPage}
        setPageSizeState={setPageSize}
        apiPagination={true}
        apiPageTotal={pageTotal}
        apiRowsTotal={rowsTotal}
        apiPageCurrentIndex={page}
        setModelFilter={setFilterModel}
      />
    </Box>
  );
};

export default AccountingsDataContent;